$(document).ready(function() {
  console.log('announcement');
  console.log($('.announcement').length);
  if ($('.announcement').length > 0) {
    console.log('announcement');
    $('body').addClass('has-announcement');
  }
  $(document).on('click', '.copy-btn', function () {
        const textToCopy = $(this).siblings('.text-to-copy').text();
        navigator.clipboard.writeText(textToCopy)
            .then(() => {
                alert('Code copied to clipboard: ' + textToCopy);
            })
            .catch(err => {
                console.error('Failed to copy text: ', err);
            });
    });
  if($('.announcement').length){
    $('.announcement').parent().addClass('announcement_wrapper');
    if (window.innerWidth <= 767) {
      $('.site-header').css('top',$('.announcement').outerHeight(true));
    }
    //$('.site-header').addClass('hasAnnouncement').css('top',$('.announcement').outerHeight(true));
    //$('#NavDrawer').css('top',$('.announcement').outerHeight(true));
    $('#PageContainer').addClass('hasAnnouncementBar');

     window.addEventListener('scroll', function () {
      const bar = document.querySelector('.announcement');
      if (window.scrollY > 0) {
        //bar.classList.add('hidden');
        //$('.site-header').removeClass('hasAnnouncement').css('top','-28px');
      //  $('#NavDrawer').css('top',0);
      } else {
        //bar.classList.remove('hidden');
        //$('.site-header').removeClass('hasAnnouncement').css('top','0');
        //$('.site-header').addClass('hasAnnouncement').css('top',$('.announcement').outerHeight(true));
       // $('#NavDrawer').css('top',$('.announcement').outerHeight(true));
      }
    });
  }
  setTimeout(function() {
         console.log('doc ready');
  console.log($('div[option-name="Style"]').length);
  $('div[option-name="Style"] ul li').on('click',function() {
    console.log('style select');
    setTimeout(function() {
        // Your jQuery code here
     $('div[option-name="Color"] ul li span').click()

    }, 500);
  });
    }, 5000);
    $('.clear-cart').on('click', function() {

       $.ajax({
            type: 'POST',
            url: '/cart/clear.js',
            dataType: 'json',
            success: function() {
                // Successfully cleared the cart, update cart UI here
                $('.cart-items').empty(); // Clear items in the cart UI
                $('.cart-total').text('0.00'); // Update total price if applicable
            },
            error: function() {
                console.error('Failed to clear the cart.');
            }
        });
    });
});
$(document).ready(function() {

  // Close popup when "X" is clicked
  $('.close-popup').click(function() {
    $('#newsletter-popup').fadeOut();
    //$('#products-popup').fadeOut();
    $('#products-popup').css('visibility','hidden');
    return false;
  });

  // Optional: Close the popup when the user clicks outside the content area
  $(window).click(function(event) {
    if ($(event.target).is('#newsletter-popup')) {
      $('#newsletter-popup').fadeOut();
    }
  });

});
$(document).ready(function () {
  //$('.popup-overlay').css('visibility','visible');
  //$('.popup-overlay').hide();
  $('.popup-footer .btn.checkout').click(function(){
    $('.btn.cart__checkout').click();
  });
});

function removeFromCart(event, itemId) {
     event.preventDefault();  // Prevent form submission or default action
     event.stopPropagation(); // Stop event from bubbling up
     event.stopImmediatePropagation(); // Stop other event listeners on the same element
     console.log(itemId);
     console.log('removeFromCart triggered');
      //return false;
     fetch('/cart/change.js', {
         method: 'POST',
         headers: {
             'Content-Type': 'application/json'
         },
         body: JSON.stringify({
             id: itemId,
             quantity: 0
         })
     })
     .then(response => response.json())
     .then(cart => {
         updateCartUI(cart,itemId);
     })
     .catch(error => console.error("Error:", error));

     return false; // Prevent further handling
 }

// Function to update cart UI dynamically
function updateCartUI(cart, itemId) {
    // Remove the item from the cart UI
    let itemElement = document.querySelector(`.cart_item_${itemId}`);
    if (itemElement) {
        itemElement.remove();
    }
    console.log(cart);
    // Update cart total price
    let cartTotalElement = document.querySelector("div[data-subtotal]");
    if (cartTotalElement) {
        let cartTotal = cart.items_subtotal_price / 100; // Convert cents to dollars
        cartTotalElement.textContent = `$${cartTotal.toFixed(2)}`;
    }

    // Hide cart if empty
    if (cart.item_count === 0) {
        let cartContainer = document.querySelector("#CartDrawer .drawer__scrollable");
        if (cartContainer) {
            //cartContainer.innerHTML = "Your cart is empty.";
        }
      //drawer__footer
      let cartFooter = document.querySelector("#CartDrawer .drawer__footer");
        if (cartContainer) {
            //cartFooter.remove();
            $('.cart-link__bubble').removeClass('cart-link__bubble--visible');
        }
    }
}

$(document).ready(function() {
  setTimeout(function () {
  if ($(window).width() <= 767) {

    $('.grid').each(function() {
      var $grid = $(this);
      var $container = $grid.find('> .product-grid-container'); // Only direct children
      var $items = $container.find('.grid__item');
      console.log($container.length);
      if ($items.length === 0) return; // Skip if no items

      $container.remove(); // Remove original container

      for (var i = 0; i < $items.length; i += 2) {
        var $newContainer = $('<div class="product-grid-container"></div>');
        $newContainer.append($items.slice(i, i + 2));
        $grid.append($newContainer);
      }
    });
  }
      $('.grid-overflow-wrapper .grid, .grid .product-grid-container').each(function() {
        var $grid = $(this);
        var addClass = false;

        $grid.find('ul.swatch-view').each(function() {
          if ($(this).find('li').length > 2) {
            addClass = true;
            return false; // Exit loop early since we found one
          }
        });

        if (addClass) {
          $grid.find('ul.swatch-view').addClass('extra-height');
        }
      });
  }, 2000);

});
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.header-item [data-disclosure-form]').forEach(function (el) {
    new theme.Disclosure(el);
  });
});
document.querySelectorAll(' [data-disclosure-option]').forEach(option => {
  option.addEventListener('click', function(e) {

    const redirectUrl = e.currentTarget.getAttribute('data-redirect-url');
    if (redirectUrl) {
      e.preventDefault();
      e.stopImmediatePropagation(); // Stop other handlers (like Shopify’s Disclosure logic)
      console.log(redirectUrl);
      window.location.href = redirectUrl;
    }
  });
});

 document.addEventListener("DOMContentLoaded", function () {
  // Check if the fieldset with name="Texture" exists
  const textureFieldset = document.querySelector('fieldset.variant-input-wrap[name="T"]');

  if (textureFieldset) {
    // Hide the parent div
    const parentDiv = textureFieldset.closest('div');
    if (parentDiv) {
      parentDiv.style.display = "none";
    }
    const smoothOption = document.querySelector('div.variant-input[data-value="S"] label');
    //Rough
    const roughOption = document.querySelector('div.variant-input[data-value="R"] label');
    // fetch("https://ipapi.co/json/")
    //       .then(res => res.json())
    //       .then(data => {
    //           console.log("Detected country:", data.country); // e.g. "CA"
    //           if (data.country === "US") {
    //               // Trigger click on div.variant-input[data-value="Smooth"]

    //               if (smoothOption) {
    //                 console.log('Smooth');
    //                 smoothOption.click();
    //               }
    //           }
    //           else {
    //              if (roughOption) {
    //                 console.log('roughOption');
    //                 roughOption.click();
    //               }
    //           }
    //       })
    //       .catch(err => console.error(err));

  }
});
document.addEventListener("DOMContentLoaded", function () {
    // Only run if on sixzeropickleball.com domain

    if (window.location.hostname == "www.sixzeropickleball.com" &&
        window.location.pathname.endsWith("/apps/product-registration")) {


            console.log("reg : NFS register");

             fetch("/browsing_context_suggestions.json")
                  .then(res => res.json())
                  .then(data => {
                        const country = data?.detected_values?.country?.handle;



                    const NORTH_AMERICA_COUNTRIES = [
                      "US", "MX", "BM", "GL", "PM",
                      "GT", "BZ", "SV", "HN", "NI", "CR", "PA",
                      "BS", "CU", "JM", "HT", "DO",
                      "KN", "LC", "VC", "BB", "GD", "AG", "DM", "TT"
                    ];

                    const params = new URLSearchParams(window.location.search);
                    const id = params.get("ID");

                    if (!id) return;
                    console.log("reg : Detected country:", country);
                    // 🇨🇦 Canada → CA store
                    if (country === "CA") {
                      window.location.href =
                        `https://sixzerocanada.com/apps/product-registration?ID=${encodeURIComponent(id)}`;
                    }

                    // 🌎 North America (except CA) → US store
                    else if (NORTH_AMERICA_COUNTRIES.includes(country)) {
                      window.location.href =
                        `https://us.sixzeropickleball.com/apps/product-registration?ID=${encodeURIComponent(id)}`;
                    }
                  })
                  .catch(err => console.error("Geo-location error:", err));


        }
        else {
        // fetch('https://ipapi.co/json/') // You can use another geo-location API if needed
        // .then(response => response.json())
        // .then(data => {

        //     if (data.country === "CA") {
        //          console.log('Canada user');
        //           eraseCookie('localization');
        //           eraseCookie('mdApp_countryCodeDomain');
        //           console.log(window.location.pathname);
        //       let redirectUrl = "https://sixzerocanada.com/"+window.location.pathname;


        //         const urlParams = new URLSearchParams(window.location.search);
        //         const scaRef = urlParams.get('sca_ref');

        //         if (scaRef) {
        //               redirectUrl += `&sca_ref=${encodeURIComponent(scaRef)}`;

        //         }

        //         window.location.href = redirectUrl;


        //     }
        // })
        // .catch(error => console.error('Geo-location error:', error));

      const ua = navigator.userAgent.toLowerCase();

const botPatterns = [
  "googlebot",
  "google-inspectiontool",
  "googleother",
  "adsbot-google",
  "bingbot",
  "bingpreview",
  "duckduckbot",
  "yandexbot",
  "baiduspider",
  "slurp"
];

const isBot = botPatterns.some(bot => ua.includes(bot));
console.log('check bot');
console.log(ua);

if (isBot) {
  console.log("Bot detected — skipping geo redirect");
  return;
}

          const STORES = {
        US: "us.sixzeropickleball.com",
        //US: "sixzeropickleball.com",
        CA: "sixzerocanada.com",
        MAIN: "sixzeropickleball.com"
        };

      const NORTH_AMERICA_COUNTRIES = [
        "US", "MX", "BM", "GL", "PM",
        "GT", "BZ", "SV", "HN", "NI", "CR", "PA",
        "BS", "CU", "JM", "HT", "DO",
        "KN", "LC", "VC", "BB", "GD", "AG", "DM", "TT"
      ];

      const params = new URLSearchParams(window.location.search);

      // 🔕 Bypass redirect if param exists
      if (
        params.get("geo_redirect") === "off" ||
        params.get("geo_bypass") === "true"
      ) {
        sessionStorage.setItem('geo_redirect', "off");

      }
      if (
        params.get("geo_redirect") === "on" ||
        params.get("geo_bypass") === "false"
      ) {
        sessionStorage.setItem('geo_redirect', "on");

      }
      if (sessionStorage.getItem('geo_redirect')=="off") return;

      const currentHost = window.location.hostname;
      const currentPath = window.location.pathname;
      const currentQuery = window.location.search;

      // Prevent redirect loops
      const sessionKey = "geo_redirect_done";
      //if (sessionStorage.getItem(sessionKey)) return;
      console.log('geo redirect');
      fetch("/browsing_context_suggestions.json")
        .then(res => res.json())
        .then(data => {
          const country = data?.detected_values?.country?.handle;

          let targetDomain = null;

          // 🇨🇦 Canada → CA store
          if (country === "CA") {
            if (currentHost !== STORES.CA) {
              targetDomain = STORES.CA;
            }
          }

          // 🌎 North America (except CA) → US store
         else if (NORTH_AMERICA_COUNTRIES.includes(country)) {
           if (currentHost !== STORES.US) {
             targetDomain = STORES.US;
           }
         }
            // 🌍 Outside North America
          else {
            if (
              currentHost === STORES.US ||
              currentHost === STORES.CA
            ) {
              targetDomain = STORES.MAIN;
            }
          }

          if (targetDomain) {
            sessionStorage.setItem(sessionKey, "true");

            eraseCookie("localization");
            eraseCookie("mdApp_countryCodeDomain");

            window.location.href =
              `https://${targetDomain}${currentPath}${currentQuery}`;
          }
        })
        .catch(err => console.error("Geo-location error:", err));
      }
           function eraseCookie(name) {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=' + location.hostname + ';';
    }
});

/* =================================================================
 SIZE GUIDE — For Image Size Guide
 ================================================================= */
(function () {
   const sizeGuideEl = document.querySelector('.grid-product__sizeguide');
   if (!sizeGuideEl) return;
   const imageUrl = window.__sizeGuideImageUrl || '';
   // Create modal elements
   const overlay = document.createElement('div');
   overlay.id = 'size-guide-overlay';
   Object.assign(overlay.style, {
     display: 'none',
     position: 'fixed',
     inset: '0',
     background: 'rgba(0,0,0,0.6)',
     zIndex: '9999',
     alignItems: 'center',
     justifyContent: 'center',
   });
   const modal = document.createElement('div');
   Object.assign(modal.style, {
     position: 'relative',
     background: '#fff',
     borderRadius: '8px',
     padding: '16px',
     maxWidth: '90vw',
     maxHeight: '90vh',
     overflow: 'auto',
     boxSizing: 'border-box',
     display: 'flex',
     alignItems: 'center',
     justifyContent: 'center',
   });
   const closeBtn = document.createElement('button');
   closeBtn.innerHTML = '&times;';
   Object.assign(closeBtn.style, {
     position: 'absolute',
     top: '8px',
     right: '12px',
     background: 'none',
     border: 'none',
     fontSize: '24px',
     cursor: 'pointer',
     lineHeight: '1',
     color: '#333',
   });
   const img = document.createElement('img');
   img.src = imageUrl;
   img.alt = 'Size Guide';
   Object.assign(img.style, {
     display: 'block',
     maxWidth: '100%',
     maxHeight: 'calc(90vh - 64px)',
     width: 'auto',
     height: 'auto',
     margin: 'auto',
   });
   img.onload = function () {
     modal.style.width = img.naturalWidth + 32 + 'px';
   };
   modal.appendChild(closeBtn);
   modal.appendChild(img);
   overlay.appendChild(modal);
   document.body.appendChild(overlay);
   function openModal() {
     overlay.style.display = 'flex';
     document.body.style.overflow = 'hidden';
   }
   function closeModal() {
     overlay.style.display = 'none';
     document.body.style.overflow = '';
   }
   sizeGuideEl.style.cursor = 'pointer';
   sizeGuideEl.addEventListener('click', openModal);
   closeBtn.addEventListener('click', closeModal);
   overlay.addEventListener('click', function (e) {
     if (e.target === overlay) closeModal();
   });
   document.addEventListener('keydown', function (e) {
     if (e.key === 'Escape') closeModal();
   });
 })();

/* =================================================================
   SIZE GUIDE — For Html Table
   ================================================================= */
document.addEventListener('DOMContentLoaded', () => {
  initSizeGuideModals();
});

function initSizeGuideModals() {
  document.querySelectorAll('.size-guide-trigger').forEach(trigger => {
    const modalId = trigger.getAttribute('aria-controls');
    const modal   = document.getElementById(modalId);
    if (!modal) return;

    const closeBtn = modal.querySelector('.sg-modal__close');

    trigger.addEventListener('click', () => openModal(modal));
    closeBtn.addEventListener('click', () => closeModal(modal));

    modal.addEventListener('click', e => {
      if (e.target === modal) closeModal(modal);
    });

    modal.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeModal(modal);
    });
  });
}

function openModal(modal) {
  modal.removeAttribute('hidden');
  modal.classList.add('is-opening');
  modal.removeEventListener('animationend', onOpenEnd);
  modal.addEventListener('animationend', onOpenEnd, { once: true });
  document.body.style.overflow = 'hidden';
  modal.focus();
}

function closeModal(modal) {
  modal.classList.remove('is-opening');
  modal.classList.add('is-closing');
  modal.addEventListener('animationend', () => {
    modal.setAttribute('hidden', '');
    modal.classList.remove('is-closing');
    document.body.style.overflow = '';
  }, { once: true });
}

function onOpenEnd(e) {
  e.target.classList.remove('is-opening');
}

/* =================================================================
 SIZE GUIDE — CM/INCH Toggle
 ================================================================= */

let currentUnit = 'cm';

function setUnit(unit) {
  if (unit === currentUnit) return;
  currentUnit = unit;

  // Update toggle button states
  document.getElementById('btn-cm').classList.toggle('active', unit === 'cm');
  document.getElementById('btn-in').classList.toggle('active', unit === 'in');
  document.getElementById('btn-cm').setAttribute('aria-pressed', unit === 'cm');
  document.getElementById('btn-in').setAttribute('aria-pressed', unit === 'in');

  // Swap all measurement cells
  document.querySelectorAll('td[data-cm]').forEach(function(td) {
    td.textContent = td.getAttribute('data-' + unit);
  });
}

// Init to cm
setUnit('cm');


const rebuyHiddenVariantIds = [
    '48916732903728-1 '
];

function hideRebuyVariants() {

    document.querySelectorAll('.rebuy-product-block').forEach(function(product) {

        // Dropdown options
        product.querySelectorAll('.rebuy-select option').forEach(function(option) {

            if (rebuyHiddenVariantIds.includes(option.value)) {
                option.remove();
            }

        });

        // Radio / button swatches
        product.querySelectorAll('.rebuy-product-options__button-swatch').forEach(function(swatch) {

            const input = swatch.querySelector('input');

            if (input && rebuyHiddenVariantIds.includes(input.value)) {
                swatch.remove();
            }

        });

    });
}

hideRebuyVariants();

const rebuyVariantObserver = new MutationObserver(function() {
    hideRebuyVariants();
});

rebuyVariantObserver.observe(document.body, {
    childList: true,
    subtree: true
});


document.addEventListener('DOMContentLoaded', function () {

  const colorMap = {
    'chalk': '#E8E4D8',
    'blue': '#0066FF',
    'navy': '#000080',
    'black': '#000000',
    'white': '#FFFFFF',
    'red': '#FF0000',
    'green': '#008000',
    'yellow': '#FFD700',
    'orange': '#FFA500',
    'pink': '#FFC0CB',
    'purple': '#800080',
    'grey': '#808080',
    'gray': '#808080',
    'brown': '#8B4513',
    'beige': '#F5F5DC',

    // Apparel colours
    'ocean blue': '#0077BE',
    'barely pink': '#F7D6D9',
    'skyway': '#87CEEB',
    'opal black print': '#1C1C1C',
    'opal white print': '#F5F5F5',
    'dazzling blue': '#3A75C4',
    'violet': '#a6236b',
    'burgundy': '#800020',
    'ruby red': '#E0115F',
    'cherry blossom pink' : '#FFB7C5',
    'teal' : '#008080',
    'amethyst': '#9966CC',
    'light purple' : '#800080',
    'ruby': '#E0115F',
    'black and grey logo' : '#000000',
    'black and white logo': '#000000',
    'pink and white logo' : '#FFC0CB',
    'white and black logo' : '#FFFFFF',
    'red with white logo' : '#FF0000'
  };

  function addApparelColorNames() {

    // Only run on Apparel products
    const productSection = document.querySelector(
      '[data-is-apparel="true"]'
    );

    if (!productSection) return;

    // Find the Color option
    const colorOption = productSection.querySelector(
      '[option-name="Color"]'
    );

    if (!colorOption) return;

    // Find Swatch King swatches
    const swatches = colorOption.querySelectorAll(
      '.swatch-view-item'
    );

    swatches.forEach(function (swatch) {

      // Get original value
      const origValue = swatch.getAttribute('orig-value');

      if (!origValue) return;

      /*
       * Examples:
       * Chalk with Black Logo
       * Ocean Blue with White Logo
       * Barely Pink with Black Logo
       * Skyway with Black Logo
       */
      const colorName = origValue
  .split(/\s+(?:with|and)\s+/i)[0]
  .trim();

      if (!colorName) return;

      const colorKey = colorName.toLowerCase();

      const colorValue = colorMap[colorKey];

      if (!colorValue) {
        console.log('No color mapping found for:', colorName);
        return;
      }

      // Find the title element inside the same LI
      const titleElement = swatch.querySelector(
        '.swatch-button-title-text'
      );

      if (!titleElement) return;

      // Don't add twice
      if (titleElement.querySelector('.apparel-color-option')) {
        return;
      }

      // Create colour span
      const span = document.createElement('span');

      span.className = 'apparel-color-option';

      span.style.backgroundColor = colorValue;

      span.setAttribute('title', colorName);
      span.setAttribute('aria-label', colorName);

      // Add span as FIRST child of .swatch-button-title-text
      titleElement.insertBefore(
        span,
        titleElement.firstChild
      );

    });
  }

  // Initial check
  addApparelColorNames();

  // Watch for Swatch King dynamically adding/rebuilding elements
  const observer = new MutationObserver(function () {
    addApparelColorNames();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});

document.addEventListener('DOMContentLoaded', function () {

  const product = document.querySelector('[data-is-apparel="true"]');

  if (!product) return;

  product.addEventListener('click', function (event) {

    const swatchButton = event.target.closest('.swatch-button');

    if (!swatchButton) return;

    // Wait for Swatch King to update swatch-selected
    setTimeout(function () {

      const colorOption = product.querySelector(
        '[option-name="Color"]'
      );

      if (!colorOption) return;

      const selected = colorOption.querySelector(
        '.swatch-button.swatch-selected'
      );

      if (!selected) return;

      const value = selected.getAttribute('orig-value');

      if (!value) return;

      const label = colorOption.querySelector(
        'legend > label'
      );

      if (!label) return;

      let span = label.querySelector(
        '.selected-apparel-color'
      );

      if (!span) {
        span = document.createElement('span');
        span.className = 'selected-apparel-color';
        label.appendChild(span);
      }

      span.textContent = ' : ' + value;

    }, 50);

  });
 
});
document.addEventListener('DOMContentLoaded', function () {

  const colorMap = {
    'chalk': '#E8E4D8',
    'blue': '#0066FF',
    'navy': '#000080',
    'black': '#000000',
    'white': '#FFFFFF',
    'red': '#FF0000',
    'green': '#008000',
    'yellow': '#FFD700',
    'orange': '#FFA500',
    'pink': '#FFC0CB',
    'purple': '#800080',
    'grey': '#808080',
    'gray': '#808080',
    'brown': '#8B4513',
    'beige': '#F5F5DC',
    'ocean blue': '#0077BE',
    'barely pink': '#F7D6D9',
    'skyway': '#87CEEB',
    'opal black print': '#1C1C1C',
    'opal white print': '#F5F5F5',
    'dazzling blue': '#3A75C4',
    'violet': '#8F00FF',
    'burgundy': '#800020',
    'ruby red': '#E0115F',
    'ruby': '#E0115F',
    'cherry blossom pink' : '#FFB7C5',
    'teal' : '#008080',
    'amethyst': '#9966CC',
    'light purple' : '#800080',
    'ruby': '#E0115F',
     'black and grey logo' : '#000000',
    'black and white logo': '#000000',
    'pink and white logo' : '#FFC0CB',
    'white and black logo' : '#FFFFFF',
    'red with white logo' : '#FF0000'
  };


  function createApparelSwatches(product) {

    const colorOption = product.querySelector(
      '[option-name="Color"]'
    );

    if (!colorOption) return;

    // Don't create twice
    if (
      colorOption.querySelector(
        '.apparel-grid-color-swatches'
      )
    ) {
      return;
    }

    const dropdownList = colorOption.querySelector(
      '.swatch-drop-down-list'
    );

    if (!dropdownList) return;

    const items = dropdownList.querySelectorAll(
      'li.swatch-drop-down-list-item[orig-value]'
    );

    if (!items.length) return;

    // Create our own visible container
    const container = document.createElement('div');

    container.className = 'apparel-grid-color-swatches';

    items.forEach(function (item) {

      const origValue = item.getAttribute('orig-value');

      if (!origValue) return;

      // Example:
      // Burgundy with White Logo -> Burgundy
      const colorName = origValue
  .split(/\s+(?:with|and)\s+/i)[0]
  .trim();

      if (!colorName) return;

      const colorValue =
        colorMap[colorName.toLowerCase()];

      if (!colorValue) return;

      // Create visible button
      const button = document.createElement('button');

      button.type = 'button';

      button.className = 'apparel-grid-color-option';

      button.style.backgroundColor = colorValue;

      button.setAttribute('title', colorName);
      button.setAttribute('aria-label', colorName);

      // Keep reference to Swatch King option
      button._swatchKingItem = item;

      /*
       * Click our swatch ->
       * click the actual Swatch King option
       */
  button.addEventListener('click', function (event) {

  event.preventDefault();
  event.stopPropagation();

  // Remove selected from all custom colours
  container
    .querySelectorAll('.apparel-grid-color-option')
    .forEach(function (swatch) {
      swatch.classList.remove('selected');
    });

  // Select clicked colour
  button.classList.add('selected');

  // Get the colour value from Swatch King
  const colorValue = item.getAttribute('orig-value');

  if (!colorValue) return;

  console.log('Selected color:', colorValue);

  /*
   * Find the real Shopify colour links
   */
  const colorLinks = product.querySelectorAll(
    '.grid-product__colors a.color-swatch'
  );

  let matchingLink = null;

  colorLinks.forEach(function (link) {

    const ariaLabel =
      link.getAttribute('aria-label') || '';

    /*
     * aria-label example:
     *
     * Womens Basic Short Sleeve Cotton Tee -
     * Chalk with Black Logo
     */

    if (
      ariaLabel.toLowerCase().includes(
        colorValue.toLowerCase()
      )
    ) {
      matchingLink = link;
    }

  });


  if (!matchingLink) {

    console.log(
      'No matching color link found:',
      colorValue
    );

    return;
  }


  /*
   * Get the exact URL containing the
   * correct Shopify variant ID
   */
  const variantUrl =
    matchingLink.getAttribute('href');

  console.log(
    'Matching variant URL:',
    variantUrl
  );


  /*
   * Update the main grid product link
   */
  const productLink = product.querySelector(
    'a.grid-product__link'
  );

  if (productLink) {

    productLink.href = variantUrl;

    console.log(
      'grid-product__link updated:',
      productLink.href
    );

  }

});

      container.appendChild(button);

    });

    /*
     * Put our swatches BEFORE the Swatch King dropdown
     */
    const wrapper = colorOption.querySelector(
      '.swatch-drop-down-wrapper'
    );

    if (wrapper) {
      wrapper.parentNode.insertBefore(
        container,
        wrapper
      );
    } else {
      colorOption.appendChild(container);
    }

    updateSelectedSwatch(container, items);
  }


  function updateSelectedSwatch(container, items) {

    items.forEach(function (item, index) {

      const button = container.children[index];

      if (!button) return;

      if (
        item.getAttribute('aria-selected') === 'true'
      ) {
        button.classList.add(
          'apparel-grid-color-selected'
        );
      } else {
        button.classList.remove(
          'apparel-grid-color-selected'
        );
      }

    });
  }


  function processApparelProducts() {

    const products = document.querySelectorAll(
      '[data-is-apparel="true"]'
    );

    products.forEach(function (product) {
      createApparelSwatches(product);
    });
  }


  // Initial load
  processApparelProducts();


  /*
   * Swatch King creates the dropdown dynamically,
   * so watch for new elements.
   */
  const observer = new MutationObserver(function () {
    processApparelProducts();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});